"use client";

import { MinusIcon, PlusIcon } from "@heroicons/react/24/solid";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { AccordionContent, AccordionItem, Accordion as BaseAccordion, cn } from "@ubud-ui/react-ui-kit";
import Link from "next/link";
import Markdown from "react-markdown";

export type TAccordion = {
  id: number;
  question: string;
  answer: string;
};

function AccordionTriggerCustom({ className, children, ...props }: AccordionPrimitive.AccordionTriggerProps) {
  return (
    <AccordionPrimitive.Trigger
      className={cn(
        "group flex flex-1 items-center text-left justify-between gap-6 py-6 font-semibold transition-all w-full text-lg md:text-xl",
        className,
      )}
      {...props}
    >
      {children}
      <div
        className={cn(
          "size-8 min-w-8 transition-all duration-300 rounded-full inline-flex items-center justify-center text-center bg-gray-100",
          "group-data-[state=open]:bg-primary",
          "group-data-[state=open]:text-white",
        )}
      >
        <MinusIcon className="size-5 hidden group-data-[state=open]:inline-block" />
        <PlusIcon className="size-5 group-data-[state=open]:hidden" />
      </div>
    </AccordionPrimitive.Trigger>
  );
}

export function Accordion({ accordions }: { accordions: TAccordion[] }) {
  return (
    <BaseAccordion type="single" collapsible className="w-full -mt-7" defaultValue={"accordion-" + accordions[0]?.id}>
      {accordions.map((accordion) => {
        return (
          <AccordionItem
            key={"accordion-" + accordion.id}
            value={"accordion-" + accordion.id}
            className="border-b border-b-gray-200 data-[state=open]:border-b-primary-600 data-[state=open]:border-b-2"
          >
            <AccordionTriggerCustom className="leading-[140%]">{accordion.question}</AccordionTriggerCustom>
            <AccordionContent className="pb-6 text-base sm:text-lg text-gray-500 leading-[140%]">
              <Markdown
                components={{
                  a(props) {
                    return (
                      <Link className="text-primary font-medium" {...props} href={props.href as string} target="_blank">
                        {props.children}
                      </Link>
                    );
                  },
                }}
              >
                {accordion.answer}
              </Markdown>
            </AccordionContent>
          </AccordionItem>
        );
      })}
    </BaseAccordion>
  );
}
